import React from "react";
import PropTypes from "prop-types";
import { Container } from "@components/atoms";
import { Box, Text } from "rebass";

export const QuoteBlock = ({ title }) => {
  return (
    <Container>
      <Box maxWidth="74rem" mx="auto">
        <Text variant="heroSubtitle" as="p" textAlign="center">
          "{title}"
        </Text>
      </Box>
    </Container>
  );
};

QuoteBlock.propTypes = {
  title: PropTypes.string.isRequired,
};
